import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { InputWrapper } from '../../../components/input/input.style'
import { Input } from '../../../components/input'
import {
    Container,
    MainContentWrapper,
    Heading,
    PageWrapper,
    UploadButton,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { CalendarComponent } from '../../../components/calendar'
import { CalendarGrid } from '../../../styles/calendar'
import EventChart from "../../../components/event-chart"
import { CustomModal } from '../../../components/modal'
import { Button } from '../../../components/button';
import { TimeTableEvents } from '../../../components/admin-timetable-event'
import { SelectInput } from '../../../components/select/select';
import { AssignmentInputButtonContainer } from '../../../styles/assignment/assignment';

const schema = yup.object().shape({
    school: yup.string().required("School is a required field"),
    class: yup.string().required("Class is a required field"),
    eventType: yup.string().required("Event Type is a required field"),
    subjectCode: yup.string().required("Subject Code is a required field"),
    term: yup.string().required("Term is a required field"),
    venue: yup.string().required("Venue is a required field"),
    startTime: yup.string().required("Start Time is a required field"),
    endTime: yup.string().required("End Time is a required field"),
    date: yup.date().required("Date is a required field").typeError('Invalid Date'),

});

const AdminTimeTables = () => {

    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];
    const [showModal, setShowModal] = useState(false);
    const [imageUploadValue, setImageUploadValue] = useState('')
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
        control
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });
    // const formData = JSON.stringify(watch());

    const onSubmit = values => {
        console.log(values)
        setShowModal(false)
    }

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }

    return (
        <>

            <CustomModal title="Add Event" onClose={() => setShowModal(false)} showModal={showModal} hasSubmitBtn >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <p style={{ marginTop: '2.4rem', fontSize: '1.2rem', fontWeight: '700', color: '#969696', }}>*You can make bulk uploads my using the Bulk upload field</p>
                    <InputWrapper>
                        <Controller
                            control={control}
                            name="school"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="school"
                                        type="text"
                                        placeholder="Select School"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.school?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />
                    </InputWrapper>
                    <InputWrapper className="grid-2-2">
                        <Controller
                            control={control}
                            name="class"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="class"
                                        type="text"
                                        placeholder="Select class"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.class?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />
                        <Controller
                            control={control}
                            name="eventType"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="eventType"
                                        type="text"
                                        placeholder="Event Type"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.eventType?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />

                    </InputWrapper>
                    <InputWrapper className="grid-2-2">
                        <Controller
                            control={control}
                            name="subjectCode"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="subjectCode"
                                        type="text"
                                        placeholder="Subject/Subject Code"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.subjectCode?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />
                        <Controller
                            control={control}
                            name="term"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="term"
                                        type="text"
                                        placeholder="Select Term"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.term?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />

                    </InputWrapper>
                    <InputWrapper className="grid-2-2">
                        <Input
                            type="text"
                            fullWidth
                            placeholder="Venue"
                            {...register("venue")}
                            error={errors.venue?.message}
                        />
                        <Input
                            type="date"
                            fullWidth
                            placeholder="Venue"
                            {...register("date")}
                            error={errors.date?.message}
                        />

                    </InputWrapper>
                    <InputWrapper className="grid-2-2">
                        <Input
                            id="startTime"
                            type="time"
                            label="Start Time"
                            placeholder="Start Time"
                            error={errors.startTime?.message}
                            {...register("startTime")}
                        />

                        <Input
                            id="endTime"
                            type="time"
                            label="End Time"
                            placeholder="End Time"
                            error={errors.endTime?.message}
                            {...register("endTime")}
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <AssignmentInputButtonContainer>
                            <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />

                            <label htmlFor="contained-button-file">
                                <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                <UploadButton variant="contained" component="span"
                                    disableElevation
                                    color="primary"
                                >
                                    BROWSE
                                </UploadButton>
                            </label>

                        </AssignmentInputButtonContainer>
                        <p style={{ marginTop: '1.6rem', fontSize: '1rem', color: '#969696', }}>*Uploaded file must be csv with the following headers; Name, Description, School Code, Highest Level etc.</p>
                    </InputWrapper>
                    <Button variant="primary" type="submit">
                        ADD
                    </Button>
                </form>
            </CustomModal>


            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <PageWrapper>
                            <Heading>
                                Timetable
                            </Heading>
                            <Breadcrumb
                                crumbs={['Timetable']}
                            />
                            <div style={{
                                marginBottom: '3rem'
                            }}>
                                <Button style={{
                                    marginLeft: 'auto',
                                }} size="small" onClick={() => setShowModal(true)}>ADD EVENT</Button>
                            </div>
                            <CalendarGrid>

                                <CalendarComponent />
                                <div style={{
                                    backgroundColor: "#fff"
                                }}>
                                    <EventChart />
                                </div>
                            </CalendarGrid>
                            <TimeTableEvents scroll />
                        </PageWrapper>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper>
        </>
    )
}

export default AdminTimeTables
